import { getPrecintas } from "../services/Rest.jsx";
import useFetch from "./useFetch";

const usePrecintas = (year) => {
  return useFetch(getPrecintas, true, year);
};

export default usePrecintas;
